import React from 'react'
import { theme } from '../../../theme/theme'
import { Icon, IconChoices } from '../../common/Icon'
import { Divider } from '../../common/Divider'
import { downloadDocumentFile } from '../../../api/documents'
import { PostDocument } from '../../../generated/api/post-row'

interface PostDocumentsProps {
  documents: PostDocument[]
  disabled?: boolean
}

export const PostDocuments = ({
  documents,
  disabled,
}: PostDocumentsProps): JSX.Element | null => {
  if (documents.length === 0) {
    return null
  }

  const downloadDocument = (id: string, filename: string): void => {
    if (!disabled) {
      downloadDocumentFile(id, filename)
    }
  }

  return (
    <>
      <Divider />
      <div className="flex flex-col gap-4">
        {documents.map((doc) => (
          <button
            key={doc.id}
            className={`flex min-w-0 flex-row items-center gap-3 whitespace-nowrap rounded
              bg-neutral-96 py-4 px-5 ${!disabled ? 'hover:bg-neutral-90' : ''}`}
            onClick={() => downloadDocument(doc.id, doc.filename)}
            disabled={disabled}
          >
            <Icon icon={IconChoices.DOCUMENT} size={24} />
            <span
              className="overflow-hidden text-ellipsis"
              style={theme.textVariants.baseBold}
            >
              {doc.name}
            </span>
            <Icon icon={IconChoices.ARROW} size={24} highlighted />
          </button>
        ))}
      </div>
    </>
  )
}
